export const LOCALE = {
    UNITED_KINGDOM: 0,
    UKRAINE: 1,
    INTERNATIONAL: 2,
    SPAIN: 3,
    PORTUGAL: 4,
    BRAZIL: 5,
    POLAND: 6,
    GERMANY: 7,
    UNITED_STATES: 9,
    MEXICO: 10,
};

export const LOCALE_KEY = {
    GB: 'GB',
    UA: 'UA',
    International: 'International',
    ES: 'ES',
    PT: 'PT',
    BR: 'BR',
    PL: 'PL',
    DE: 'DE',
    US: 'US',
    MX: 'MX',
};

// Anything outside this list falls back to the international locale.
export const SIGNUP_LOCALES = [
    LOCALE_KEY.GB,
    LOCALE_KEY.UA,
    LOCALE_KEY.PT,
    LOCALE_KEY.ES,
    LOCALE_KEY.BR,
    LOCALE_KEY.MX,
];
